import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1" data-id="element-140" data-mp="k294no01quwl">
      <span className="font-display text-2xl font-extrabold tabular-nums leading-none" data-id="element-141" data-mp="k429cxr3n51y">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-semibold uppercase tracking-wider text-white/55" data-id="element-142" data-mp="abei0iiw1tam">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Cuenta regresiva de la oferta" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-obsidian text-white" data-id="element-143" data-mp="1agc1uow3bpe">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-3 px-4 sm:gap-5" data-id="element-144" data-mp="my9npsq53936">
        <p className="flex items-center gap-1.5 whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-ember sm:text-xs" data-id="element-145" data-mp="10y16s7vijfo1">
          <TimerIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-146" data-mp="vyy42u309lj8" />
          La oferta termina en:
        </p>
        <p className="flex items-baseline gap-1.5" aria-live="off" data-id="element-147" data-mp="86rag2onzsni">
          <Unit value={mm} label="Min" data-id="element-148" data-mp="3b25tkxsflkc" />
          <span className="font-display text-xl font-bold text-white/40" data-id="element-149" data-mp="37wiaa4t4rqq">:</span>
          <Unit value={ss} label="Seg" data-id="element-150" data-mp="hzydhgvxmwkf" />
        </p>
      </div>
    </div>;
}